module.exports = __webpack_public_path__ + "static/img/rongyu4.69b8f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyu4.jpg
// module id = F3vX
// module chunks = 1